var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassHideIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B8085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#svg_14a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.587 6.587a2 2 0 1 0 2.826 2.826m-2.26-6.026c.281-.035.564-.053.847-.054C12.667 3.333 14.667 8 14.667 8a8.78 8.78 0 0 1-1.114 1.787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.407 4.407A9.017 9.017 0 0 0 1.333 8s2 4.667 6.667 4.667a6.493 6.493 0 0 0 3.594-1.074M1.333 1.333l13.334 13.334"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_14a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassHideIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pass-hide-icon.5e3b3cb3c93cca8dfcccbb1544fa7cc2.svg";